"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Footer = void 0;
const AppContext_1 = require("../../utils/AppContext");
const use_media_1 = require("use-media");
const react_1 = __importStar(require("react"));
const styled_components_1 = __importStar(require("styled-components"));
const FooterContainer = styled_components_1.default.div `
   border-spacing: 0px;

   position: absolute;
   bottom: 0;
   width: 100%;

   font-size: 11px;
   font-weight: normal;
   line-height: 21px;
   color: white;

   background-color: black;
   background-image: linear-gradient(#404040, #515151);
`;
const PaddedContainer = styled_components_1.default.div `
   padding-left: 20px;
   padding-right: 20px;
`;
const FooterLeft = styled_components_1.default.span `
   width: 230px;
   float: left;
   left: 0px;
   text-align: left;
   position: relative;
`;
const CenterMarketingSlogan = styled_components_1.default.span `
   width: 100%;
   text-align: center !important;
   position: absolute;
   display: block;
`;
const FooterRight = styled_components_1.default.span `
   width: 200px;
   float: right;
   right: 0px;
   text-align: right;
   position: relative;
`;
const FooterLearnMoreLink = styled_components_1.default.a.attrs(props => {
    return { href: props.href, target: props.target };
}) `
   color: ${props => props.theme["app-link-color"]};
   text-shadow: none;
   &:hover {
      color: ${props => props.theme["hover-color"]};
   }
`;
exports.Footer = (props) => {
    const theme = react_1.useContext(styled_components_1.ThemeContext);
    const appContext = react_1.default.useContext(AppContext_1.AppContext);
    const version = appContext.config && appContext.config.version
        ? appContext.config.version
        : null;
    const isBranded = theme["name"] === "Trimble Pulse";
    const marketingPhrases = [
        "SOFTWARE FOR THE WORKFORCE ON THE MOVE",
        "CONTROL YOUR FIELD SERVICE OPS IN A SINGLE, EASY TO USE APPLICATION",
        "EXPERTS IN MOBILE INSPECTION SOFTWARE",
        "WITH IOT, TRANSFORM MACHINE HEALTH DATA INTO PROACTIVE SERVICE ACTIONS",
        "GET THE MOST OUT OF YOUR FIELD WORKFORCE",
        "IMPROVE CUSTOMER SATISFACTION",
        "SIMPLIFYING CRITICAL FIELD SERVICE OPS FOR COMPANIES LARGE TO SMALL"
    ];
    const tooSmallForSlogan = use_media_1.useMedia({ maxWidth: 900 });
    const randomNumber = Math.floor(Math.random() * marketingPhrases.length) + 1;
    return (react_1.default.createElement(FooterContainer, null,
        !isBranded && !tooSmallForSlogan ? (react_1.default.createElement(CenterMarketingSlogan, null, marketingPhrases[randomNumber - 1])) : null,
        react_1.default.createElement(PaddedContainer, null,
            react_1.default.createElement(FooterLeft, null,
                "\u00A9\u00A0",
                theme["name"],
                " ",
                new Date().getFullYear(),
                version ? react_1.default.createElement(react_1.default.Fragment, null,
                    "\u00A0- Version: ",
                    version) : null),
            react_1.default.createElement(FooterRight, null,
                "Learn more about\u00A0",
                react_1.default.createElement(FooterLearnMoreLink, { href: "http://www.msidata.com", target: "_blank" }, "MSI Data, LLC.")))));
};
//# sourceMappingURL=Footer.js.map